askSchoolSpecificQuestions.classy.controller({
    name: 'iframeModalController',
    inject: ['$scope', '$sce', 'authServiceFactory', 'AskSchoolSpecificQuestionsModelService', 'StandardModalCudFactory', '$modalInstance'],
    init: function()
    {
        //this.$.modalCud = new this.StandardModalCudFactory(this.AskSchoolSpecificQuestionsModelService,
        //   this.authServiceFactory.getAuth().schoolID, this.item, this, [], this.index, this.$modalInstance);
        this.$.auth = this.authServiceFactory.getAuth();
        this.$.$modalInstance = this.$modalInstance;
        let domain = this.authServiceFactory.getDomain();
        this.$.previewURL = "https://" + domain + "/family_side/scForSqPreview.php?schoolID=" + this.$.auth.schoolID;
        this.$.previewURL = this.$sce.trustAsResourceUrl(this.$.previewURL);
    }
});